export enum BeneficiaryTab {
  INFORMATION = "",
  PROGRAM = "program",
  TRACKING = "tracking",
  TELECARE = "telecare",
}

export enum DashboardTab {
  BENEFICIARIES = "beneficiaries",
  MEETINGS = "meetings",
  PROFILE = "profile",
}
